<template>
  <div>
    <v-card class="card" link to="/menu/en/sandwich">
      <v-card-title>Sandwiches</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/en/toast">
      <v-card-title>Toast</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/en/pizza">
      <v-card-title>Pizza</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/en/salads">
      <v-card-title>Salads</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/en/beverage">
      <v-card-title>Beverages</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/en/sides">
      <v-card-title>Sides</v-card-title>
    </v-card>
    <v-card class="card" link to="/menu/en/icecream">
      <v-card-title>Ice cream</v-card-title>
    </v-card>
  </div>
</template>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 1.2rem auto;
  max-width: 18rem;
  text-align: center;
}
.button {
  background-color: #dc143c;
  color: white;
  max-width: 100px;
}
</style>
<script setup>
</script>